import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { onlyLeter, required, type } from "@/commons/utils/Rules";
import 'element-ui/lib/theme-chalk/display.css';
import PzBaseForm1 from "@/components/Flujo/Formularios/Formularios1/baseForm1";
import PzFormFlujo from "@/components/Flujo/Templates/PzFormFlujoTemplate";
import { getEstadoCivil, getRelacionesLaborales } from "@/routes/api/resources";
import PzIdentityDocument from "@/commons/forms/Fields/PzIdentityDocument.vue";
export default {
  name: 'PzPersonForm2Fucerep',
  components: {
    PzIdentityDocument: PzIdentityDocument,
    PzFormFlujo: PzFormFlujo
  },
  mixins: [PzBaseForm1],
  data: function data() {
    var _this = this;
    var check_telefono = function check_telefono(rule, value, callback) {
      var regla = '^(0)(\\d{8})$';
      var pattern = new RegExp(regla.toString());
      if (pattern.test(value)) {
        return callback();
      }
      return callback(new Error(_this.$t('rules.invalid_field', {
        name: rule.field
      })));
    };
    var check_Fecha = function check_Fecha(rule, value, callback) {
      localStorage.setItem('isjubilado', true);
      if (_this.formulario1.relacion_laboral_id != 4) localStorage.setItem('isjubilado', false);
      if (_this.formulario1.relacion_laboral_id != 4 && _this.formulario1.relacion_laboral_id != 16 && !value) {
        return callback(new Error(_this.$t('rules.incomplete')));
      }
      return callback();
    };
    return {
      marital_status: [],
      relacion_laboral: [],
      genero: [{
        id: 'f',
        name: this.$t('forms_flujo.form1_persona.SP.femenino')
      }, {
        id: 'm',
        name: this.$t('forms_flujo.form1_persona.SP.masculino')
      }],
      reference: 'formulario1',
      formulario1: {
        primer_nombre: '',
        segundo_nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        telefono: '',
        genero: '',
        estado_civil_id: '',
        email: '',
        relacion_laboral_id: '',
        fecha_nacimiento: '',
        fecha_ingreso: '',
        cuota_maxima: '',
        ingreso_mensual: '',
        destino_prestamo: '',
        jubilado: null,
        identity: {
          document: 1
        },
        comprobante_domicilio: null,
        comprobante_ingresos: null,
        clearing: null,
        sucursal_id: ''
      },
      rules_formulario1: {
        /*'identity.document': [required('')],
        'identity.number': [Cedula('')],*/
        primer_nombre: [onlyLeter(), required('')],
        apellido_paterno: [onlyLeter(), required('')],
        segundo_nombre: [onlyLeter()],
        apellido_materno: [onlyLeter()],
        fecha_nacimiento: [required('')],
        genero: [required('')],
        estado_civil_id: [required('')],
        telefono: [required(''), {
          validator: check_telefono,
          trigger: 'blur'
        }],
        cuotas: [required('')],
        monto_prestamo: [required('')],
        relacion_laboral_id: [required('')],
        cuota_maxima: [required(''), type({
          field: '',
          type: 'number'
        })],
        ingreso_mensual: [required(''), type({
          field: '',
          type: 'number'
        })],
        destino_prestamo: [required('')],
        fecha_ingreso: [{
          validator: check_Fecha,
          trigger: 'blur'
        }],
        email: [type({
          field: '',
          type: 'email'
        })]
      },
      pickerOptions1: {
        disabledDate: function disabledDate(time) {
          return Date.now() < time.getTime();
        }
      }
    };
  },
  computed: {
    isjubilado: function isjubilado() {
      return this.formulario1.relacion_laboral_id && (this.formulario1.relacion_laboral_id == '4' || this.formulario1.relacion_laboral_id == '16');
    }
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;
      this.$store.dispatch('loader/up', {
        trigger: this.$options.name
      });
      var estado = getEstadoCivil().then(function (res) {
        _this2.marital_status = res.data;
      }).catch(function () {
        _this2.marital_status = [];
      });
      var re = getRelacionesLaborales().then(function (res) {
        _this2.relacion_laboral = res.data;
      }).catch(function () {
        _this2.relacion_laboral = [];
      });
      return Promise.all([estado, re]).then(function () {}).finally(function () {
        _this2.$store.dispatch('loader/down', {
          trigger: _this2.$options.name
        });
      });
    }
  }
};